import { VisitStatus } from '@curebase/core/types';
import isDataCaptureCompleted from './isDataCaptureCompleted';
import isDataCaptureMissed from './isDataCaptureMissed';

export default function isDataCaptureSubmitted(visit: {
  status: VisitStatus;
}): boolean {
  return isDataCaptureMissed(visit) || isDataCaptureCompleted(visit);
}
